import React, { ChangeEvent } from 'react';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import { Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import { colors } from '../themes/colors';

const styles = (theme: Theme) => ({
  selectInput: {
    ...theme.typography.body1,
    minWidth: 300,
    color: colors.black5,
    fontWeight: 800,
    '& ul li.Mui-selected': {
      fontSize: 14,
      backgroundColor: colors.gray5,
      color: colors.white1,
      '&:hover': {
        backgroundColor: colors.gray3,
      },
    },
  },
});

type Props = WithStyles & {
  value: string;
  multiple?: boolean;
  onChange: (event: ChangeEvent<{ name?: string; value: unknown }>) => void;
  extraClass?: string;
};

const MHSelect: React.FC<Props> = ({
  classes,
  value,
  multiple,
  onChange,
  children,
  extraClass,
}) => (
  <FormControl className={classes.textField} margin="dense">
    <Select
      className={extraClass ? extraClass : classes.selectInput}
      value={value}
      onChange={onChange}
      multiple={!!multiple}
      MenuProps={{ classes: { paper: classes.selectInput } }}
      input={<OutlinedInput id="select-multiple" labelWidth={0} />}
    >
      {children}
    </Select>
  </FormControl>
);

export default withStyles(styles)(MHSelect);
